export default "__VITE_ASSET__95357645__"